import TransferList from '@sophocles/components/TransferList/TransferList';

export default TransferList;
